export default "__VITE_ASSET__1a312e08__"